import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import i18n, { LANGUAGES, dirFor } from "@/i18n";
import api from "@/lib/api";

const LangContext = createContext(null);
export const useLang = () => useContext(LangContext);

function applyDir(lang) {
  const dir = dirFor(lang);
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", lang);
  return dir;
}

export function LangProvider({ children }) {
  const { t } = useTranslation();
  const [lang, setLangState] = useState(i18n.language?.split("-")[0] || "en");
  const [dir, setDir] = useState(dirFor(lang));

  useEffect(() => { setDir(applyDir(lang)); }, [lang]);

  const setLang = useCallback(async (code) => {
    await i18n.changeLanguage(code);
    localStorage.setItem("drivons_lang", code);
    setLangState(code);
    setDir(applyDir(code));
    // persist to profile if logged in (cross-device persistence)
    if (localStorage.getItem("drivons_token")) {
      api.patch("/me/preferences", { language: code }).catch(() => {});
    }
  }, []);

  return (
    <LangContext.Provider value={{ lang, dir, setLang, languages: LANGUAGES, t, isRTL: dir === "rtl" }}>
      {children}
    </LangContext.Provider>
  );
}
